import React, { useContext, useMemo } from 'react';
import { ContextMenu } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useUser from '@ubeya/shared/hooks/auth/useUser';

const CostCenterActionsRenderer = ({ rowData, columnData: { onEdit, onDelete } }) => {
  const { t } = useContext(ConfigContext);
  const { isUbeyaAdmin } = useUser();

  const options = useMemo(
    () => [
      { label: t('edit'), onClick: () => onEdit(rowData) },
      {
        label: t('Delete (Super Admin Only)'),
        onClick: () => onDelete(rowData),
        visible: !!rowData?.id && onDelete && isUbeyaAdmin,
        confirm: true,
        confirmBody: t('areYouSureYouWantToDelete'),
        confirmText: 'delete',
        confirmPortal: true
      }
    ],
    [isUbeyaAdmin, onDelete, onEdit, rowData, t]
  );

  return <ContextMenu options={options} usePortal />;
};

export default CostCenterActionsRenderer;
